import {RouteObject} from 'react-router'

import {ATTENDANCE_STATUS} from '.'
import {USER_TYPES_NUMERIC} from './user'

export const ATTENDANCE_SHOW_ROUTES: RouteObject[] = [
  {path: '/institute/attendance/*'},
  {path: '/institute/attendanceReport/*'},
  {path: '/institute/userCustomAtendanceSchedule/admin'},
]

export const CAMPUS_ATTENDANCE_FILTER_TYPES = {
  Branch: 1,
  Level: 2,
  Grade: 3,
  Class: 4,
}

export const AUTOMATED_ATTENDANCE_ALERT_FREQUENCY_VALUES = [
  {
    label: 'ATTENDANCE.AUTOMATED_ALERT.MONTHLY',
    value: 1,
    // tooltip: 'ATTENDANCE.AUTOMATED_ALERT.MONTHLY.HELPER_TEXT',
  },
  {
    label: 'ATTENDANCE.AUTOMATED_ALERT.WEEKLY',
    value: 2,
    // tooltip: 'ATTENDANCE.AUTOMATED_ALERT.WEEKLY.HELPER_TEXT',
  },
]

/**
 * Values stored in attendance_setting.automated_attendance_alert_recipients.
 * 1/2/3 are USER_TYPES_NUMERIC codes; mentor/counsellor are student-relative
 * roles (user_student.mentor_id / counseller_id + secondary tables), not user
 * types, so they use codes above the user-type range. Must match
 * AttendanceSetting.AUTOMATED_ATTENDANCE_ALERT_RECIPIENT_* in ilmversity-node.
 */
export const AUTOMATED_ATTENDANCE_ALERT_RECIPIENT = {
  STUDENT: USER_TYPES_NUMERIC.STUDENT,
  TEACHER: USER_TYPES_NUMERIC.TEACHER,
  PARENT: USER_TYPES_NUMERIC.PARENT,
  MENTOR: 6,
  COUNSELLOR: 7,
}

export const AUTOMATED_ATTENDANCE_ALERT_RECIPIENT_OPTIONS = [
  {label: 'MENU.STUDENT', value: AUTOMATED_ATTENDANCE_ALERT_RECIPIENT.STUDENT},
  {label: 'MENU.TEACHER', value: AUTOMATED_ATTENDANCE_ALERT_RECIPIENT.TEACHER},
  {label: 'MENU.PARENTS', value: AUTOMATED_ATTENDANCE_ALERT_RECIPIENT.PARENT},
  {label: 'USER.MENTOR', value: AUTOMATED_ATTENDANCE_ALERT_RECIPIENT.MENTOR},
  {label: 'USER.COUNSELLOR', value: AUTOMATED_ATTENDANCE_ALERT_RECIPIENT.COUNSELLOR},
]

export const CAMPUS_ATTENDANCE_FILTER_TYPES_LABELS = [
  // {label: 'MENU.BRANCHES', value: 1},
  // {label: 'MENU.LEVEL', value: 2},
  {label: 'MENU.GRADES', value: 3},
  {label: 'MENU.CLASS', value: 4},
]

export const ATTENDANCE_BETA_TOGGLE_TENANTS = [
  'demo',
  'democollege',
  'myschool',
  'mgs',
  'lihs',
  'wlgs',
  'concordia',
  'rayden',
  'nis',
  'pss',
]

export const ATTENDANCE_URL_FOR_BRANCH_SELECTION = [
  '/institute/attendance/teacher',

  '/institute/attendance/teacher-report/individual',
  '/institute/attendance/teacher-report/combine',
  '/institute/attendance/teacher-report/monthly',
  '/institute/attendance/teacher-report/monthly-combine',

  '/institute/attendance/teacher-subject',
  '/institute/attendance/teacher-subject-report/individual',
  '/institute/attendance/teacher-subject-report/combine',
  '/institute/attendance/teacher-subject-report/roster',

  '/institute/attendance/student',
  '/institute/attendance/student-report/individual',
  '/institute/attendance/student-report/combine',
  '/institute/attendance/student-report/classwise',
  '/institute/attendance/student-report/monthwise-summary',

  '/institute/attendance/student-subject',
  '/institute/attendance/student-subject-report/individual',
  '/institute/attendance/student-subject/combined-report',
  '/institute/attendance/student-subject-report/combine',
  '/institute/attendance/student-subject-report/monthly',
  '/institute/attendance/student-subject-report/subjectwise-summary',

  // '/institute/attendance-custom-schedule/add-schedules',
]

export const ATTENDANCE_GRID_URLS = [
  '/institute/attendance/teacher',
  '/institute/attendance/teacher-subject',
  '/institute/attendance/student',
  '/institute/attendance/student-subject',
]

export const REPORT_TITLE_CONSTANTS = {
  TEACHER_STAFF_INDIVIDUAL: 'TEACHER_STAFF_INDIVIDUAL',
  TEACHER_STAFF_COMBINE: 'TEACHER_STAFF_COMBINE',
  TEACHER_STAFF_MONTHLY_INDIVIDUAL: 'TEACHER_STAFF_MONTHLY_INDIVIDUAL',
  TEACHER_STAFF_MONTHLY_COMBINE: 'TEACHER_STAFF_MONTHLY_COMBINE',

  TEACHER_SUBJECT_INDIVIDUAL: 'TEACHER_SUBJECT_INDIVIDUAL',
  TEACHER_SUBJECT_COMBINE: 'TEACHER_SUBJECT_COMBINE',
  TEACHER_SUBJECT_ROSTER: 'TEACHER_SUBJECT_ROSTER',

  STUDENT_INDIVIDUAL: 'STUDENT_INDIVIDUAL',
  STUDENT_COMBINE: 'STUDENT_COMBINE',
  STUDENT_CLASSWISE: 'STUDENT_CLASSWISE',
  STUDENT_MONTHWISE: 'STUDENT_MONTHWISE',

  STUDENT_SUBJECT_INDIVIDUAL: 'STUDENT_SUBJECT_INDIVIDUAL',
  STUDENT_SUBJECT_COMBINE: 'STUDENT_SUBJECT_COMBINE',
  STUDENT_SUBJECT_MONTHLY: 'STUDENT_SUBJECT_MONTHLY',
  STUDENT_SUBJECT_SUBJECTWISE: 'STUDENT_SUBJECT_SUBJECTWISE',
}

export const getReportTitle: (title: string, type: any, data?: any) => string = (
  title,
  type,
  data = null
) => {
  if (title === REPORT_TITLE_CONSTANTS.TEACHER_STAFF_INDIVIDUAL) {
    if (type.length > 1) {
      return 'All Teacher(s) / Staff Attendance Report'
    }
    return data[0]?.full_name + "'s Attendance Report"
  } else if (title === REPORT_TITLE_CONSTANTS.TEACHER_STAFF_COMBINE) {
    if (type.length > 1) {
      return 'All Teacher(s) / Staff Attendance Report'
    } else {
      if (type[0] === USER_TYPES_NUMERIC.TEACHER) {
        return 'All Teacher(s) Attendance Report'
      }
      return 'All Staff Attendance Report'
    }
  }
  // else if (title === REPORT_TITLE_CONSTANTS.TEACHER_STAFF_MONTHLY_INDIVIDUAL) {
  // } else if (title === REPORT_TITLE_CONSTANTS.TEACHER_STAFF_MONTHLY_COMBINE) {
  // }
  else if (title === REPORT_TITLE_CONSTANTS.TEACHER_SUBJECT_INDIVIDUAL) {
    if (type.length > 1) {
      return 'All Teacher(s) Attendance Report'
    }
    return data[0]?.full_name + "'s Attendance Report"
  } else if (title === REPORT_TITLE_CONSTANTS.TEACHER_SUBJECT_COMBINE) {
    if (data && data.length > 0) {
      return data[0] + ' Subjects Teacher Attendance Report'
    }
    return 'Teacher Subject Combine Attendance Report'
  }
  // } else if (title === REPORT_TITLE_CONSTANTS.TEACHER_SUBJECT_ROSTER) {
  // } else if (title === REPORT_TITLE_CONSTANTS.STUDENT_INDIVIDUAL) {
  // } else if (title === REPORT_TITLE_CONSTANTS.STUDENT_COMBINE) {
  else if (title === REPORT_TITLE_CONSTANTS.STUDENT_CLASSWISE) {
    if (type && type.length === 1) {
      return `${type[0]} Attendance Summary`
    }
    return 'All Classes Attendance Summary'
  }
  // else if (title === REPORT_TITLE_CONSTANTS.STUDENT_MONTHWISE) {
  // }
  else if (title === REPORT_TITLE_CONSTANTS.STUDENT_SUBJECT_INDIVIDUAL) {
    return data[0]?.full_name + "'s Attendance Report"
  } else if (title === REPORT_TITLE_CONSTANTS.STUDENT_SUBJECT_COMBINE) {
    if (type.length > 1) {
      return 'All Subjects(s) Attendance Report'
    }
    return data[0]?.subject_name + ' Attendance Report'
  }
  // else if (title === REPORT_TITLE_CONSTANTS.STUDENT_SUBJECT_MONTHLY) {
  // } else if (title === REPORT_TITLE_CONSTANTS.STUDENT_SUBJECT_SUBJECTWISE) {
  // }
  return 'Attendance Report'
}

export const getAttendanceStatusLetterAndColor = (
  status: number,
  late_present: string = 'Late'
): {letter: string; color: string; tooltip?: string} => {
  switch (status) {
    case ATTENDANCE_STATUS.STATUS_ABSENT:
      return {letter: 'A', color: 'danger', tooltip: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_ABSENT'}
    case ATTENDANCE_STATUS.STATUS_BUNK:
      return {letter: 'B', color: 'danger', tooltip: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_BUNK'}
    case ATTENDANCE_STATUS.STATUS_LEAVE:
      return {letter: 'L', color: 'info', tooltip: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_LEAVE'}
    case ATTENDANCE_STATUS.STATUS_PRESENT:
      return {letter: 'P', color: 'success', tooltip: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_PRESENT'}
    case ATTENDANCE_STATUS.STATUS_LATE_PRESENT:
      return {
        letter: late_present.charAt(0),
        color: 'warning',
        tooltip: 'ATTENDANCE.ATTENDANCE_GRID.STATUS_LATE',
      }
    default:
      return {letter: '-', color: 'secondary'}
  }
}
